import { createClient } from '@supabase/supabase-js';

const {
  VITE_SUPABASE_PROJECT_URL: PROJECT_URL,
  VITE_SUPABASE_ANON_KEY: PROJECT_KEY,
} = import.meta.env;

export const baseApi = createClient(PROJECT_URL, PROJECT_KEY);
